export const lastUpdated = {
  date: "2026-10-10",
  time: "09:30",
  note: "线路状态每日巡检，如遇个别线路异常请优先切换备用线路。",
};

export const navLinks = [
  { id: "entry", label: "最新入口" },
  { id: "causes", label: "打不开原因" },
  { id: "fix", label: "解决方法" },
  { id: "download", label: "APP下载" },
  { id: "permanent", label: "永久入口" },
  { id: "faq", label: "常见问题" },
];

export const entryLinks = [
  {
    id: "e1",
    name: "星辰影院主入口",
    domain: "www.xcyy-hall.com",
    status: "正常",
    speed: "极速",
    region: "电信 / 联通 / 移动",
    note: "三网线路均可用，日常观影首选，高峰时段同样稳定。",
    tag: "推荐",
  },
  {
    id: "e2",
    name: "备用线路 A",
    domain: "vip.xingchen-live.net",
    status: "正常",
    speed: "流畅",
    region: "联通 / 移动",
    note: "深夜至凌晨时段表现更好，主入口拥堵时可优先切换。",
    tag: "备用",
  },
  {
    id: "e3",
    name: "备用线路 B",
    domain: "movie.xc-hall.cc",
    status: "维护中",
    speed: "一般",
    region: "电信",
    note: "正在同步新片数据，预计 2 小时内恢复，请暂时使用其他线路。",
    tag: "维护",
  },
  {
    id: "e4",
    name: "海外加速入口",
    domain: "go.xc-global.tv",
    status: "正常",
    speed: "流畅",
    region: "海外网络",
    note: "面向海外用户优化，回国加速后可正常观看。",
    tag: "加速",
  },
  {
    id: "e5",
    name: "老用户迁移入口",
    domain: "old.xc-move.info",
    status: "正常",
    speed: "极速",
    region: "全线路",
    note: "打开后会自动跳转到当前最新主域名，旧书签可继续使用。",
    tag: "迁移",
  },
];

export const causes = [
  {
    id: "c1",
    icon: "ri-shield-cross-line",
    title: "域名被网络屏蔽",
    desc: "部分运营商会对影视类站点域名进行拦截，表现为一直转圈、无法连接，或跳到运营商的提示页。这是最常见的原因。",
  },
  {
    id: "c2",
    icon: "ri-global-line",
    title: "DNS 解析异常",
    desc: "本地 DNS 缓存过期或被污染时，浏览器找不到服务器地址，会出现「无法访问此网站」或解析失败的提示。",
  },
  {
    id: "c3",
    icon: "ri-wifi-off-line",
    title: "本地网络波动",
    desc: "Wi-Fi 信号弱、路由器长时间未重启、多人共用一个网络时带宽被占满，都会造成打开缓慢甚至超时。",
  },
  {
    id: "c4",
    icon: "ri-bug-2-line",
    title: "浏览器缓存与插件冲突",
    desc: "残留的旧缓存或广告拦截、脚本拦截类插件，可能误拦页面必要资源，导致页面白屏或样式错乱。",
  },
  {
    id: "c5",
    icon: "ri-tools-line",
    title: "官方维护或更换线路",
    desc: "站点更新主域名、切换服务器期间，旧地址会短暂失效。这类情况通常几小时内自动恢复。",
  },
  {
    id: "c6",
    icon: "ri-time-line",
    title: "观看高峰拥堵",
    desc: "晚间 20:00–23:00 为观影高峰，单条线路并发过高时会变慢，切换备用线路即可明显改善。",
  },
];

export const fixSteps = [
  {
    id: "s1",
    step: "01",
    title: "先换一条备用线路",
    desc: "绝大多数「打不开」都能用这招解决。回到本页上方的「最新可用入口」，在主入口和备用线路之间切换，通常立刻恢复。",
    tip: "建议同时收藏 2–3 条线路，避免只依赖一个地址。",
  },
  {
    id: "s2",
    step: "02",
    title: "刷新本地 DNS 缓存",
    desc: "Windows 可在命令提示符执行 ipconfig /flushdns；手机开启飞行模式约 10 秒再关闭，可清掉旧的解析记录。",
    tip: "操作后重新打开浏览器，不要直接刷新旧标签页。",
  },
  {
    id: "s3",
    step: "03",
    title: "切换网络环境对比",
    desc: "在 Wi-Fi 与移动数据之间来回切换，或换一台设备测试。若换网络就能打开，说明是原网络被限制。",
    tip: "用手机热点连接电脑，是最快的对比方式。",
  },
  {
    id: "s4",
    step: "04",
    title: "清理浏览器缓存与插件",
    desc: "清除近期缓存和 Cookie，或直接用无痕窗口打开。若装了广告拦截类插件，可暂时关闭后重试。",
    tip: "换一个浏览器（如 Edge、Chrome）往往也能直接绕过。",
  },
  {
    id: "s5",
    step: "05",
    title: "更换公共 DNS 服务器",
    desc: "把网络 DNS 改为公共 DNS，如 223.5.5.5、119.29.29.29 或 1.1.1.1，可绕过被污染的解析结果。",
    tip: "改完记得保存并重连一次网络再访问。",
  },
  {
    id: "s6",
    step: "06",
    title: "改用官方 APP 客户端",
    desc: "网页端持续异常时，客户端走的是独立接口，稳定性更高，也更少受到浏览器环境的干扰。",
    tip: "下载前请认准本页给出的官方渠道，勿用来路不明的安装包。",
  },
  {
    id: "s7",
    step: "07",
    title: "通过永久入口找回最新地址",
    desc: "当所有线路都失效，说明官方正在更换主域名。此时请通过本页「永久入口」中介绍的方式获取最新可用地址。",
    tip: "收藏本页或订阅通知，是成本最低的防走失方式。",
  },
];

export const downloadOptions = [
  {
    id: "android",
    platform: "Android",
    icon: "ri-android-line",
    size: "约 46 MB",
    requirement: "Android 8.0 及以上",
    highlight: "覆盖面最广，支持安卓手机与平板。",
    steps: [
      "在本页点击 Android 客户端下载入口",
      "下载完成后，如系统提示「未知来源」需在设置中允许安装",
      "安装完成后打开即可进入首页，无需注册即可浏览",
      "首次进入建议在设置中开启「省流播放」",
    ],
  },
  {
    id: "ios",
    platform: "iOS",
    icon: "ri-apple-line",
    size: "约 58 MB",
    requirement: "iOS 14.0 及以上",
    highlight: "画质与播放器表现最均衡，适合追剧。",
    steps: [
      "使用 Safari 浏览器打开下载入口",
      "按页面指引完成描述文件或 TestFlight 安装",
      "安装后在「设置-通用-VPN与设备管理」中信任该应用",
      "打开 APP 即可使用，支持倍速与投屏",
    ],
  },
  {
    id: "windows",
    platform: "Windows",
    icon: "ri-windows-line",
    size: "约 82 MB",
    requirement: "Windows 10 64 位及以上",
    highlight: "大屏观看体验更好，支持硬件解码。",
    steps: [
      "下载 Windows 客户端安装包",
      "双击运行，按照向导完成安装",
      "首次启动如被安全软件拦截，请选择「允许运行」",
      "在播放设置中开启硬件加速可降低 CPU 占用",
    ],
  },
  {
    id: "tv",
    platform: "电视 / 盒子",
    icon: "ri-tv-2-line",
    size: "约 40 MB",
    requirement: "Android TV 8.0 及以上",
    highlight: "客厅大屏专属，遥控器操作优化。",
    steps: [
      "用 U 盘拷贝安装包到电视或盒子",
      "在「应用-安装未知来源应用」中允许对应文件管理器",
      "安装完成后在首页应用列表找到客户端",
      "建议连接 5G 频段 Wi-Fi 或网线以获得最佳画质",
    ],
  },
];

export const permanentMethods = [
  {
    id: "p1",
    icon: "ri-bookmark-3-line",
    title: "收藏本页作为导航",
    desc: "本页会随官方域名变动同步更新，把它加入浏览器书签，就相当于拥有一个长期有效的总入口。",
  },
  {
    id: "p2",
    icon: "ri-mail-send-line",
    title: "绑定常用邮箱",
    desc: "在客户端内绑定邮箱后，域名变更时会收到通知邮件，即使旧地址全部失效也能第一时间收到最新地址。",
  },
  {
    id: "p3",
    icon: "ri-wechat-line",
    title: "关注官方发布频道",
    desc: "官方会通过固定频道发布最新地址与维护公告，建议置顶关注，避免临时找不到入口。",
  },
  {
    id: "p4",
    icon: "ri-history-line",
    title: "记住「迁移入口」",
    desc: "迁移入口会永久指向当前主域名，即使官方更换域名，它也会自动跳转，是最省心的长期地址。",
  },
  {
    id: "p5",
    icon: "ri-file-list-3-line",
    title: "记录在本地备忘录",
    desc: "把 2–3 条常用线路手动记录在手机备忘录，配合本页收藏，几乎不可能出现彻底找不到的情况。",
  },
  {
    id: "p6",
    icon: "ri-smartphone-line",
    title: "安装客户端并保持更新",
    desc: "客户端内置线路自动切换，地址变动时无需手动更换，是长期用户最稳定的方式。",
  },
];

export const features = [
  {
    id: "f1",
    icon: "ri-film-line",
    title: "片源覆盖广",
    desc: "电影、剧集、综艺、动漫、纪录片多类内容同步更新，热门新片上线速度快。",
  },
  {
    id: "f2",
    icon: "ri-hd-line",
    title: "高清流畅播放",
    desc: "支持标清到 4K 多档清晰度切换，弱网环境可开启省流模式，自动适配带宽。",
  },
  {
    id: "f3",
    icon: "ri-device-line",
    title: "多端体验一致",
    desc: "手机、平板、电脑、电视全端覆盖，播放进度可在客户端之间同步继续观看。",
  },
  {
    id: "f4",
    icon: "ri-list-check-2",
    title: "分类与筛选清晰",
    desc: "按类型、地区、年份、语言多维度筛选，找片效率高，减少了无效翻找。",
  },
  {
    id: "f5",
    icon: "ri-refresh-line",
    title: "更新节奏及时",
    desc: "追更剧集每日固定时段更新，片单会有明确的更新时间提示，方便安排观看。",
  },
  {
    id: "f6",
    icon: "ri-user-smile-line",
    title: "免注册即可浏览",
    desc: "浏览与基础观看无需注册，减少填写流程，想看的直接打开即可。",
  },
];

export const faqs = [
  {
    id: "q1",
    q: "为什么昨天还能打开，今天却打不开了？",
    a: "最常见的原因是官方更换了主域名，或你所在的网络运营商对旧域名做了屏蔽。此时旧地址会暂时失效，请到本页「最新可用入口」切换其他线路，或通过「永久入口」获取最新地址。",
  },
  {
    id: "q2",
    q: "这些域名多久更新一次？",
    a: "本页会按官方公告和实际巡检情况更新，通常官方更换域名后数小时内就会同步。建议收藏本页，每次访问前先看一眼顶部的更新时间。",
  },
  {
    id: "q3",
    q: "手机上打开了但一直转圈，是地址问题吗？",
    a: "不一定。先切换网络（Wi-Fi 与移动数据互换）再试；若换成其他线路就正常，说明是原线路拥堵；若所有线路都转圈，多半是当前网络受限，可尝试更换 DNS 或改用客户端。",
  },
  {
    id: "q4",
    q: "不用安装 APP，只用网页版可以吗？",
    a: "可以。网页版无需安装即可浏览与观看，适合临时使用。但如果你经常观看、又常遇到域名变动，建议安装客户端，它内置线路切换，稳定性更好。",
  },
  {
    id: "q5",
    q: "网站提示需要付费或输入账号密码，正常吗？",
    a: "不正常，请立即停止操作。正规入口的浏览和基础观看无需任何支付信息或账号密码。任何索要密码、验证码、支付信息的页面都可能是仿冒站点，请从本页给出的官方入口重新进入。",
  },
  {
    id: "q6",
    q: "换了新手机，如何把使用习惯带过去？",
    a: "在新设备上安装客户端并登录同一账号（如已绑定），收藏列表与观看进度可同步。若未绑定，可在旧设备上把常用线路和片单记录手动保存下来。",
  },
];

export const safetyTips = [
  {
    id: "t1",
    icon: "ri-verified-badge-line",
    title: "认准官方入口",
    desc: "始终从本页给出的地址进入，警惕搜索引擎中的竞价广告和仿冒站点。",
  },
  {
    id: "t2",
    icon: "ri-lock-password-line",
    title: "不输入敏感信息",
    desc: "官方入口不会索要账号密码、验证码或银行卡信息，遇到请立即关闭页面。",
  },
  {
    id: "t3",
    icon: "ri-download-2-line",
    title: "谨慎下载安装包",
    desc: "只使用本页提供的官方下载渠道，来路不明的 APK 或描述文件存在风险。",
  },
  {
    id: "t4",
    icon: "ri-error-warning-line",
    title: "警惕付费解锁陷阱",
    desc: "要求付费才能观看、下载的页面基本是仿冒站，正规入口不会这样设置。",
  },
];